"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var next_intl_1 = require("next-intl");
var apps_shared_1 = require("@l2p/apps-shared");
var ui_components_1 = require("@l2p/ui-components");
var date_fns_1 = require("date-fns");
var RangePromoTimer = function (_a) {
    var startAt = _a.startAt, endAt = _a.endAt, hideFinishLabel = _a.hideFinishLabel;
    var t = (0, next_intl_1.useTranslations)('translation');
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    var isStartAfterToday = (0, react_1.useMemo)(function () { return startAt && (0, date_fns_1.isAfter)(new Date(startAt), new Date()); }, [startAt]);
    var finishDate = (0, react_1.useMemo)(function () {
        if (startAt && endAt) {
            return isStartAfterToday ? startAt : endAt;
        }
    }, [endAt, isStartAfterToday, startAt]);
    if (!finishDate)
        return null;
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.timerWrapper },
        react_1.default.createElement(ui_components_1.Timer, { endDate: finishDate, inGame: breakpoints.mobile || breakpoints.tablet, title: t("".concat(isStartAfterToday ? 'startAfter' : 'timeLeft')), hideFinishLabel: hideFinishLabel })));
};
exports.default = RangePromoTimer;
